import { render, staticRenderFns } from "./chooseaduditionLesson.vue?vue&type=template&id=5f032ce6&scoped=true"
import script from "./chooseaduditionLesson.vue?vue&type=script&lang=js"
export * from "./chooseaduditionLesson.vue?vue&type=script&lang=js"
import style0 from "./chooseaduditionLesson.vue?vue&type=style&index=0&id=5f032ce6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f032ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f032ce6')) {
      api.createRecord('5f032ce6', component.options)
    } else {
      api.reload('5f032ce6', component.options)
    }
    module.hot.accept("./chooseaduditionLesson.vue?vue&type=template&id=5f032ce6&scoped=true", function () {
      api.rerender('5f032ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontbusiness/chooseaduditionLesson.vue"
export default component.exports